<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">添加</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">

        <el-row class="row">
          <el-col :span="12" class="item">
            <div class="label">选择科室</div>
            <el-select v-model="add_DepartmentId" placeholder="请选择科室" style="width: 100%">
              <el-option
                  v-for="item in department_arr"
                  :key="item.id"
                  :label="item.departmentClassName+'/'+item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="12" class="item">
            <div class="label">岗位名称</div>
            <el-input v-model="add_Name" placeholder="请输入岗位名称"></el-input>
          </el-col>

        </el-row>
        <el-row>
          <el-col :span="12" class="item">
            <div class="label">排序</div>
            <el-input v-model="add_sort" placeholder="请输入排序"></el-input>
          </el-col>
        </el-row>

      </div>
      <div class="modal-footer">
        <el-button @click.native="closeSelf">取消</el-button>
        <el-button :loading="loading" type="primary" @click.native="confirm">提交</el-button>
      </div>
    </div>

  </div>
</template>


<script>

import {getStaffCode} from "@/utils/auth";
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: 'Add',
  props: [],
  data() {
    return {

      loading: false,

      add_Name:'',
      add_sort:0,

      add_DepartmentId:'',
      department_arr:[],


    }
  },
  methods: {
    init(){

      this.add_Name = '';
      this.add_sort = 0;

      this.getDepartment();
      //this.getClassType();

    },
    closeSelf() {
      this.loading= false
      this.$emit("closeAdd");
    },

    getDepartment(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+'Department/AdmList',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
        }

      }).then( (response)=> {
        if(response.data.error == 0){
          this.department_arr = response.data.data.list;
        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });

    },
    getClassType(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+'JobClassType/AdmList',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
        }

      }).then( (response)=> {
        if(response.data.error == 0){
          this.class_type_arr = response.data.data.list;
        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });

    },



    confirm(){

      if(this.add_Name === ''){
        this.$message("输入岗位名称");
        return;
      }
      if(this.add_DepartmentId === ''){
        this.$message("选择科室");
        return;
      }
      // if(this.add_JobClassTypeCode === ''){
      //   this.$message("选择类型");
      //   return;
      // }
      if(this.add_sort === ''){
        this.$message("输入排序");
        return;
      }

      if(this.loading){
        return;
      }else{
        this.loading = true;
      }

      this.$axios({
        method: 'post',
        url: this.$shopUrl+'JobClass/AdmAdd',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          name: this.add_Name,
          sort:this.add_sort,
          //jobClassTypeCode:this.add_JobClassTypeCode,
          departmentId:this.add_DepartmentId,
        }

      }).then( (response)=> {
        this.loading = false;
        if(response.data.error == 0){
          this.$emit("closeAdd");
          this.$emit("getList");
        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });

    },


  }
}
</script>

